import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import './Login.css';

function Login() {
  const { authenticated, login } = useContext(AuthContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Check if user is already logged in
  useEffect(() => {
    if (authenticated) {
      navigate('/dashboard');
    }
    
    // Check for remembered username
    const rememberedUsername = localStorage.getItem('rememberedUsername');
    if (rememberedUsername) {
      setUsername(rememberedUsername);
      setRememberMe(true);
    }
  }, [authenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!username || !password) {
      setError('NIK dan password harus diisi');
      return;
    }
    
    try {
      setIsLoading(true);
      await login(username, password);
      
      // Save username if remember me is checked
      if (rememberMe) {
        localStorage.setItem('rememberedUsername', username);
      } else {
        localStorage.removeItem('rememberedUsername');
      }
      
      navigate('/dashboard');
    } catch (error) {
      setError(error.message || 'Login gagal. Periksa username dan password Anda.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <div className="login-logo">
          <img src="/logo.png" alt="Company Logo" />
        </div>
        <h2>Sistem Penggajian - Login</h2>
        
        {error && <div className="alert alert-danger">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">NIK</label>
            <input
              type="text"
              id="username"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isLoading}
              />
              <button 
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                disabled={isLoading}
              >
                {showPassword ? '🔒' : '👁️'}
              </button>
            </div>
          </div>
          
          <div className="remember-me">
            <input
              type="checkbox"
              id="remember-me"
              checked={rememberMe}
              onChange={() => setRememberMe(!rememberMe)}
              disabled={isLoading}
            />
            <label htmlFor="remember-me">Remember me</label>
          </div>
          
          <button 
            type="submit" 
            className="btn btn-login"
            disabled={isLoading}
          >
            {isLoading ? 'Memproses...' : 'Login'}
          </button>
        </form>
        
        <div className="login-info">
          <p>Informasi Login:</p>
          <ul>
            <li>Gunakan NIK dan password yang diberikan</li>
            <li>Hubungi admin jika mengalami masalah</li>
          </ul>
        </div>
        
        <div className="security-notice">
          <p><strong>Perhatian:</strong> Jangan bagikan kredensial Anda dengan siapapun</p>
        </div>
        
        <div className="utility-buttons">
          <button 
            className="utility-btn utility-btn-warning" 
            onClick={() => window.location.reload()}
            disabled={isLoading}
          >
            Reset Form
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login; 